export default __webpack_public_path__ + "static/course-photo-1-b734e1db9585dcecd92f3c7f267f897d.jpg";